export default __webpack_public_path__ + "static/media/253.bb7f4573.png";